import React from "react";

const WhatsAppButton = ({ phoneNumber, message }) => {
  // WhatsApp link format: https://wa.me/<number>?text=<encodedMessage>
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#25D366", // WhatsApp green
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        textDecoration: "none",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.25)",
        transition: "all 0.3s ease",
      }}
      onMouseEnter={(e) =>
        (e.currentTarget.style.backgroundColor = "#1ebe5d")
      }
      onMouseLeave={(e) =>
        (e.currentTarget.style.backgroundColor = "#25D366")
      }
    >
      {/* WhatsApp SVG Icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="28"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 2C6.48 2 2 6.19 2 11.5c0 2.04.68 3.93 1.82 5.47L2 22l5.2-1.64A10.05 10.05 0 0012 21c5.52 0 10-4.19 10-9.5S17.52 2 12 2zm0 17c-1.64 0-3.17-.5-4.46-1.36l-.32-.21-3.09.97.99-3-.21-.34A7.43 7.43 0 014.5 11.5C4.5 7.91 8.02 5 12 5s7.5 2.91 7.5 6.5S15.98 19 12 19zm3.71-5.29c-.2-.1-1.18-.58-1.36-.65-.18-.07-.31-.1-.44.1-.13.2-.51.65-.62.78-.11.13-.23.15-.43.05-.2-.1-.84-.31-1.6-.99-.59-.52-.99-1.16-1.11-1.36-.12-.2-.01-.31.09-.41.09-.09.2-.23.3-.34.1-.11.13-.2.2-.33.07-.13.03-.25-.02-.35-.05-.1-.44-1.06-.61-1.45-.16-.39-.33-.34-.44-.35-.11-.01-.24-.01-.37-.01-.13 0-.35.05-.53.25-.18.2-.7.68-.7 1.65s.72 1.91.82 2.04c.1.13 1.41 2.15 3.42 3.02.48.21.85.34 1.14.44.48.15.92.13 1.27.08.39-.06 1.18-.48 1.35-.95.17-.47.17-.87.12-.95-.05-.08-.18-.13-.38-.23z"/>
      </svg>
    </a>
  );
};

export default WhatsAppButton;